import { Component, output } from '@angular/core';

@Component({
  selector: 'investigation-strip',
  templateUrl: './investigation-strip.component.html',
})
export class InvestigationStripComponent {
  readonly bannerClick = output<void>();

  onSeeTestsClick(): void {
    this.bannerClick.emit();
  }
}
